export default {"src":"__ASTRO_ASSET_IMAGE__HN1GEJ9Q__","width":330,"height":213,"format":"png"}